import { createSlice } from '@reduxjs/toolkit';

import { fetcherInitialState } from 'src/redux/fetcher';

import { sanitizeProjectInfo } from './sanitizers';
import {
    ProjectInfoFetcher,
    patchProjectInfoAsync,
    patchProjectInfoDescriptionFileAsync,
} from './thunk';

export const projectInfoSlice = createSlice({
    name: 'projectInfo',
    initialState: fetcherInitialState,
    reducers: {},
    extraReducers(builder) {
        ProjectInfoFetcher.reducers(builder);
        builder.addCase(patchProjectInfoAsync.pending, (state) => {
            state.status = 'loading';
            state.loading = true;
        });
        builder.addCase(patchProjectInfoAsync.fulfilled, (state, action) => {
            const sanitizedProjectInfo = sanitizeProjectInfo(action.payload);
            state.data = sanitizedProjectInfo;
            state.status = 'succeeded';
            state.loading = false;
        });
        builder.addCase(patchProjectInfoAsync.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error;
            state.loading = false;
        });
        builder.addCase(patchProjectInfoDescriptionFileAsync.pending, (state) => {
            state.status = 'loading';
            state.loading = true;
        });
        builder.addCase(patchProjectInfoDescriptionFileAsync.fulfilled, (state, action) => {
            state.data = sanitizeProjectInfo(action.payload);
            state.status = 'succeeded';
            state.loading = false;
        });
        builder.addCase(patchProjectInfoDescriptionFileAsync.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error;
            state.loading = false;
        });
    },
});
